import api from "../utils/api";

const API_URL = process.env.REACT_APP_API_URL + "/payment_milestones.php";

// Get all milestones by project ID
export const getMilestonesByProjectId = async (projectId) => {
  const response = await api.post(API_URL, {
    action: "getByProject",
    projectId: projectId,
  });
  return response.data.milestones || [];
};

// Add a new milestone
export const addMilestone = async (data) => {
  const response = await api.post(API_URL, {
    ...data,
    action: "add",
  });
  return response.data;
};

// Update a milestone
export const updateMilestone = async (data) => {
  const response = await api.post(API_URL, {
    ...data,
    action: "update",
  });
  return response.data;
};

// Delete a milestone (optional)
export const deleteMilestone = async (id) => {
  const response = await api.post(API_URL, {
    id,
    action: "delete",
  });
  return response.data;
};
